export const Features = () => {
  return (
    <section className="landing-features" id="features">
      <div className="features-container">
        <div className="features-header">
          <h2 className="features-title">Funcionalidades del Portal</h2>
          <p className="features-description">
            Todo lo que necesita para gestionar su relación comercial de manera
            eficiente
          </p>
        </div>

        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon text-center">
              <i className="bi bi-upload"></i>
            </div>
            <h3 className="feature-title">Carga de Facturas</h3>
            <p className="feature-description">
              Suba sus facturas PDF y XML con validación automática de RFC,
              montos, folios y detección de duplicados. Carga múltiple y
              confirmación inmediata.
            </p>
          </div>

          <div className="feature-card">
            <div className="feature-icon text-center">
              <i className="bi bi-graph-up"></i>
            </div>
            <h3 className="feature-title">Seguimiento en Tiempo Real</h3>
            <p className="feature-description">
              Consulte el estatus de sus facturas: recibidas, en revisión,
              aprobadas o rechazadas. Notificaciones automáticas por cada cambio
              de estado.
            </p>
          </div>

          <div className="feature-card">
            <div className="feature-icon text-center">
              <i className="bi bi-calendar-check"></i>
            </div>
            <h3 className="feature-title">Calendario de Pagos</h3>
            <p className="feature-description">
              Visualice fechas comprometidas, montos programados y planifique su
              flujo de efectivo con un calendario interactivo y reportes
              exportables.
            </p>
          </div>

          <div className="feature-card">
            <div className="feature-icon text-center">
              <i className="bi bi-cash-stack"></i>
            </div>
            <h3 className="feature-title">Control de Costos</h3>
            <p className="feature-description">
              Reportes automáticos por período, centro de costo y tipo de gasto.
              Análisis comparativo y exportación a Excel y PDF.
            </p>
          </div>

          <div className="feature-card">
            <div className="feature-icon text-center">
              <i className="bi bi-bell"></i>
            </div>
            <h3 className="feature-title">Notificaciones Automáticas</h3>
            <p className="feature-description">
              Reciba correos electrónicos por cada evento importante: recepción
              de factura, cambios de estatus y confirmación de pagos.
            </p>
          </div>

          <div className="feature-card">
            <div className="feature-icon text-center">
              <i className="bi bi-shield-lock"></i>
            </div>
            <h3 className="feature-title">Almacenamiento Seguro</h3>
            <p className="feature-description">
              Sus documentos organizados por fecha, folio y proveedor. Búsqueda
              avanzada y acceso controlado por roles.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
